<style scoped>
.query-form {
    margin-top: 40px;
}
</style>

<template>
    <div>
        <h1>首页动态</h1>
        <div class="query-form">
            <el-form ref="queryForm" :model="form" label-width="80px">
                <el-row :gutter="10">
                    <el-col :span="8">
                        <el-form-item label="关键字">
                            <el-input v-model="form.keyword" clearable />
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="状态">
                            <el-select v-model="form.status" placeholder="请选择">
                                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>                    
                    </el-col>
                    <el-col :span="8">
                        <el-form-item>
                            <el-button type="primary" @click="onSubmit">查询</el-button>
                            <el-button type="primary" @click="addMoment">发布动态</el-button>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <div>
            <el-table :data="momentList" border style="width:100%">
                <el-table-column prop="updateTime" label="最近修改时间" width="200"></el-table-column>
                <el-table-column prop="createTime" label="发布时间" width="200"></el-table-column>
                <el-table-column prop="auther" label="修改人" width="100"></el-table-column>
                <el-table-column prop="textValue" label="文案" width="400"></el-table-column>
                <el-table-column prop="defaultLike" label="默认点赞" width="100"></el-table-column>
                <el-table-column prop="templateType" label="模板类型" :formatter="templateTypeFormatter" width="100"></el-table-column>
                <el-table-column fixed="right" label="操作" width="150">
                    <template slot-scope="scope">
                        <el-button @click="showDetail(scope.row.momentId)" type="primary" size="small">编辑</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination :current-page="currentPage" :page-size="pageSize" @current-change="pageCurrentChange"
            background layout="prev, pager, next" :total="total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import app from '@/App.vue';
import { getMomentList } from '@/request/api';
export default {
    name: 'MomentList',
    data() {
      return {
        momentList: [],
        form: {
          keyword: '',
          status: 1
        },
        options: [{
            value: 1,
            label: '正常'
        }, {
            value: 3,
            label: '禁用'
        }],
        templateType: app.templateType,
        currentPage: 1,
        pageSize: 10,
        pages: 1,
        total: 0,
      };
    },
    methods: {
        onSubmit() {
            getMomentList({
                keyword: this.form.keyword,
                status: this.form.status,
                page: this.currentPage,
                size: this.pageSize
            }).then(res => {
                var status = res.status;
                var msg = res.msg;
                if (status === '2') {
                    this.$message.error(msg);
                } else {
                    this.$message.success("查询成功");
                    var data = res.data;
                    this.momentList = data.list;
                    this.currentPage = data.pageNum;
                    this.pagea = data.pages;
                    this.total = data.total;
                }
            })
        },
        pageCurrentChange(val) {
            this.currentPage = val;
            this.onSubmit()
        },
        showDetail(momentId) {
            this.$router.push("/Layout/momentDetail?momentId=" + momentId).catch(error => error);
        },
        addMoment() {
            this.$router.push("/Layout/addMoment").catch(error => error);
        },
        templateTypeFormatter(data) {
            var result = ""
            this.templateType.forEach((item,index) => {
                if (data.templateType == item.value) {
                    result = item.label
                    return;
                }
            })
            return result;
        }
    },
    created(){
        this.onSubmit();
    }
}
</script>


<style scoped>
.list-item {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin-top: 10px;
}
.text {
  font-size: 20px;
  width: 100px;
  height: 30px;
  line-height: 30px;
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/page/appIndex/momentList.vue